import { useLoaderData } from 'react-router-dom';

import AvailableRewardsPage from './AvailableRewardsPage';
import Header from './Header';
import { ReferAFriendProvider } from './ReferAFriendProvider';
import TabNavigation from './TabNavigation';

import { ApplicationLayout } from '../../Shared/layout/ApplicationLayout';
import { Referral, SenderOfferFulfillment, SenderOfferName } from '../data';

export interface ReferAFriendPageLoaderData {
  firstName: string;
  referralKey: string;
  senderOfferName: SenderOfferName;
  referralFulfillments: number;
  senderOfferFulfillments: SenderOfferFulfillment[];
  maxReferralRewardCount: number;
  hasMaximumInvestingReferrals: boolean;
  referralInvites: Referral[];
}

const ReferAFriendPage = () => {
  const {
    firstName,
    referralKey,
    senderOfferName,
    referralFulfillments,
    senderOfferFulfillments,
    maxReferralRewardCount,
    hasMaximumInvestingReferrals,
    referralInvites,
  } = useLoaderData<ReferAFriendPageLoaderData>();

  return (
    <ApplicationLayout pageTitle={`${firstName}'s Referrals`} feature="refer_a_friend">
      <ReferAFriendProvider
        referralKey={referralKey}
        senderOfferName={senderOfferName}
        senderOfferFulfillments={senderOfferFulfillments}
        hasMaximumInvestingReferrals={hasMaximumInvestingReferrals}
        referralInvites={referralInvites}
        referralFulfillments={referralFulfillments}
        maxReferralRewardCount={maxReferralRewardCount}
      >
        <ApplicationLayout.Header>
          <Header />
          <TabNavigation />
        </ApplicationLayout.Header>
        <ApplicationLayout.Content>
          <AvailableRewardsPage />
        </ApplicationLayout.Content>
      </ReferAFriendProvider>
    </ApplicationLayout>
  );
};

export default ReferAFriendPage;
